import axios from "axios";

import { BASE_URL, LOGIN_URL } from './common';

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

 
export function getAccessList() {

  var url = BASE_URL + 'accessgrp?pageSize=10000'; 

  return axios.get(url);
}

export function registerAccess(nm, descs, doorIds) {

  var params = { nm, descs, doorIds: doorIds.join(',') };

  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  
  var url = BASE_URL + 'accessgrp?' + paramStr;

  return axios.post(url, params);

}
export function deleteAccess(accessId) {
  var url = BASE_URL + 'accessgrp/' + accessId;

  return axios.delete(url);
}